<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast tm-modal-center">
    <div class="uk-modal-dialog uk-modal-body">
      <div class="uk-text-center">
        <div v-html="local_page_keys.text_drop_order"></div>
        <button type="button" class="tm-button-success uk-button uk-margin-medium-top" @click="reload">
          {{ local_page_keys.button_refrash }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
  },
  methods: {
    closeModal() {
      this.$emit('close', true);
    },
    reload() {
      this.$emit('reload', true);
    },
  },
}
</script>